"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.types = exports.TAG_WEBFORMS = exports.TAG_TUTORIAL = exports.TAG_PRODUCT_NEWS = exports.TAG_PODCAST = exports.TAG_PDFS = exports.TAG_E_SIGNATURES = exports.TAG_ENGINEERING = exports.TAG_DIGITAL_TRANSFORMATION = exports.TAG_CUSTOMER_STORIES = exports.TAG_COMPANY_NEWS = exports.SUPPORTED_LANGUAGES = exports.ROLES = exports.PRODUCT_WORKFLOWS = exports.PRODUCT_WEBFORMS = exports.PRODUCT_PDF_SERVICES = exports.PRODUCT_E_SIGN = exports.PRODUCT_DOCUMENT_AI = exports.PRODUCTS_FEATURE_PAGES = exports.PRODUCTS = exports.PRICING_PLANS = exports.PLAN_MAKER = exports.PLAN_CUSTOM = exports.BLOG_TAGS = exports.ASK_ANVIL_TAGS = void 0;
// blog tags
const TAG_DIGITAL_TRANSFORMATION = 'digital-transformation';
exports.TAG_DIGITAL_TRANSFORMATION = TAG_DIGITAL_TRANSFORMATION;
const TAG_ENGINEERING = 'engineering';
exports.TAG_ENGINEERING = TAG_ENGINEERING;
const TAG_PRODUCT_NEWS = 'product-news';
exports.TAG_PRODUCT_NEWS = TAG_PRODUCT_NEWS;
const TAG_TUTORIAL = 'tutorial';
exports.TAG_TUTORIAL = TAG_TUTORIAL;
const TAG_CUSTOMER_STORIES = 'customer-stories';
exports.TAG_CUSTOMER_STORIES = TAG_CUSTOMER_STORIES;
const TAG_COMPANY_NEWS = 'company-news';
exports.TAG_COMPANY_NEWS = TAG_COMPANY_NEWS;
const TAG_PODCAST = 'podcast';

// ask anvil tags
exports.TAG_PODCAST = TAG_PODCAST;
const TAG_PDFS = 'pdfs';
exports.TAG_PDFS = TAG_PDFS;
const TAG_WEBFORMS = 'webforms';
exports.TAG_WEBFORMS = TAG_WEBFORMS;
const TAG_E_SIGNATURES = 'e-signatures';

// products
exports.TAG_E_SIGNATURES = TAG_E_SIGNATURES;
const PRODUCT_PDF_SERVICES = 'anvil-pdf-services';
exports.PRODUCT_PDF_SERVICES = PRODUCT_PDF_SERVICES;
const PRODUCT_WORKFLOWS = 'anvil-workflows';
exports.PRODUCT_WORKFLOWS = PRODUCT_WORKFLOWS;
const PRODUCT_E_SIGN = 'anvil-e-signatures';
exports.PRODUCT_E_SIGN = PRODUCT_E_SIGN;
const PRODUCT_WEBFORMS = 'anvil-webforms';
exports.PRODUCT_WEBFORMS = PRODUCT_WEBFORMS;
const PRODUCT_DOCUMENT_AI = 'anvil-document-ai';

// pricing plans
exports.PRODUCT_DOCUMENT_AI = PRODUCT_DOCUMENT_AI;
const PLAN_MAKER = 'maker';
exports.PLAN_MAKER = PLAN_MAKER;
const PLAN_CUSTOM = 'custom';

// lnaguages
exports.PLAN_CUSTOM = PLAN_CUSTOM;
const LANGUAGE_CSS = 'css';
const LANGUAGE_HTML = 'html';
const LANGUAGE_JAVASCRIPT = 'javascript';
const LANGUAGE_TS = 'typescript';
const LANGUAGE_PYTHON = 'python';
const LANGUAGE_PHP = 'php';
const LANGUAGE_XML = 'xml';
const LANGUAGE_RUBY = 'ruby';
const LANGUAGE_JAVA = 'java';
const LANGUAGE_SHELL = 'bash';
const LANGUAGE_YAML = 'yaml';
const LANGUAGE_MARKDOWN = 'markdown';
const LANGUAGE_SQL = 'sql';
const LANGUAGE_JSON = 'json';
const LANGUAGE_JSX = 'jsx';
// doesn't have a prism language, but thats fine for now bc we wont show groq code
const LANGUAGE_GROQ = 'groq';
const LANGUAGE_GRAPHQL = 'graphql';
const LANGUAGE_GO = 'go';
const LANGUAGE_NGINX = 'nginx';
const LANGUAGE_OBJECTIVE_C = 'objectivec';
const LANGUAGE_CSHARP = 'csharp';
const LANGUAGE_DOCKERFILE = 'docker';
const LANGUAGE_PLAIN_TEXT = 'plain';
const BLOG_TAGS = [{
  value: 'Digital transformation',
  key: TAG_DIGITAL_TRANSFORMATION
}, {
  value: 'Engineering',
  key: TAG_ENGINEERING
}, {
  value: 'Product news',
  key: TAG_PRODUCT_NEWS
}, {
  value: 'Tutorial',
  key: TAG_TUTORIAL
}, {
  value: 'Customer stories',
  key: TAG_CUSTOMER_STORIES
}, {
  value: 'Company news',
  key: TAG_COMPANY_NEWS
}, {
  value: 'Podcast',
  key: TAG_PODCAST
}];
exports.BLOG_TAGS = BLOG_TAGS;
const ASK_ANVIL_TAGS = [{
  value: 'PDFs',
  key: TAG_PDFS
}, {
  value: 'Webforms',
  key: TAG_WEBFORMS
}, {
  value: 'E-signatures',
  key: TAG_E_SIGNATURES
}];
exports.ASK_ANVIL_TAGS = ASK_ANVIL_TAGS;
const PRODUCTS = [{
  value: 'PDF Services',
  key: PRODUCT_PDF_SERVICES
}, {
  value: 'Workflows',
  key: PRODUCT_WORKFLOWS
}, {
  value: 'Etch E-sign',
  key: PRODUCT_E_SIGN
}, {
  value: 'Webforms',
  key: PRODUCT_WEBFORMS
}, {
  value: 'Document AI',
  key: PRODUCT_DOCUMENT_AI
}];

// TODO: use this in marketing site
exports.PRODUCTS = PRODUCTS;
const PRODUCTS_FEATURE_PAGES = PRODUCTS.filter(_ref => {
  let {
    key
  } = _ref;
  return key !== PRODUCT_WEBFORMS;
});
exports.PRODUCTS_FEATURE_PAGES = PRODUCTS_FEATURE_PAGES;
const PRICING_PLANS = [{
  value: 'Maker',
  key: PLAN_MAKER
}, {
  value: 'Custom',
  key: PLAN_CUSTOM
}];
exports.PRICING_PLANS = PRICING_PLANS;
const ROLES = {
  // turning off blog author role for now, it's not enforced and Author is it's own document.
  // having computed properties would be amazing here again, so the Author document can
  // set this role on the person.
  // ['blog-author']: {value: 'Blog Author', key: 'blog-author'},
  'testimonial-author': {
    value: 'Testimonial Author',
    key: 'testimonial-author'
  }
  // anvil employee here?
};

// TODO: rename this... maybe fieldTypes instead?
exports.ROLES = ROLES;
const types = {
  testimonial: 'testimonial'
};
exports.types = types;
const SUPPORTED_LANGUAGES = [{
  key: LANGUAGE_CSS,
  value: 'CSS'
}, {
  key: LANGUAGE_HTML,
  value: 'HTML',
  prismLanguage: 'markup'
}, {
  key: LANGUAGE_JAVASCRIPT,
  value: 'JavaScript'
}, {
  key: LANGUAGE_TS,
  value: 'TypeScript'
}, {
  key: LANGUAGE_PYTHON,
  value: 'Python'
}, {
  key: LANGUAGE_PHP,
  value: 'PHP'
}, {
  key: LANGUAGE_XML,
  value: 'XML',
  prismLanguage: 'markup'
}, {
  key: LANGUAGE_RUBY,
  value: 'Ruby'
}, {
  key: LANGUAGE_JAVA,
  value: 'Java'
}, {
  key: LANGUAGE_SHELL,
  value: 'bash'
}, {
  key: LANGUAGE_YAML,
  value: 'yaml'
}, {
  key: LANGUAGE_MARKDOWN,
  value: 'Markdown'
}, {
  key: LANGUAGE_SQL,
  value: 'SQL'
}, {
  key: LANGUAGE_JSON,
  value: 'JSON'
}, {
  key: LANGUAGE_JSX,
  value: 'JSX'
}, {
  key: LANGUAGE_GROQ,
  value: 'GROQ'
}, {
  key: LANGUAGE_GRAPHQL,
  value: 'GraphQL'
}, {
  key: LANGUAGE_GO,
  value: 'Go'
}, {
  key: LANGUAGE_NGINX,
  value: 'nginx'
}, {
  key: LANGUAGE_OBJECTIVE_C,
  value: 'Objective-C'
}, {
  key: LANGUAGE_CSHARP,
  value: 'C#'
}, {
  key: LANGUAGE_DOCKERFILE,
  value: 'Dockerfile'
}, {
  key: LANGUAGE_PLAIN_TEXT,
  value: 'Plain Text'
}];
exports.SUPPORTED_LANGUAGES = SUPPORTED_LANGUAGES;